// @ts-nocheck
import React, { useEffect, useState } from "react";
// import { Auth } from "aws-amplify";
import { fetchAuthSession, getCurrentUser, signOut } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";

const withAdminAuth = (Component) => {
  return (props) => {
    const [isAdmin, setIsAdmin] = useState(false);
    // Resolved group list, handed to the page so it doesn't re-parse the session itself
    const [cognitoGroups, setCognitoGroups] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
      checkAdminGroup();
    }, []);

    const checkAdminGroup = async () => {
      try {
        const authSession = await fetchAuthSession();
        const groups =
          authSession?.tokens?.idToken?.payload?.["cognito:groups"] ?? [];
        if (groups && (groups.includes("Admin") || groups.includes("AdminReadOnly"))) {
          setCognitoGroups(Array.isArray(groups) ? groups : []);
          setIsAdmin(true);
        } else {
          navigate("/unauthorized"); // Redirect to unauthorized page or handle differently
        }
      } catch (error) {
        console.error("Error checking admin group", error);
        navigate("/home"); // Redirect to sign-in page
      }
    };

    // cognitoGroups is additive — pages that don't need it simply ignore the prop
    return isAdmin ? <Component {...props} cognitoGroups={cognitoGroups} /> : null;
  };
};

export default withAdminAuth;
